(function() {
    'use strict';
    angular.module('wbDashboard')
    .directive('superFocus',
    ['$animate', '$window', '$timeout',
    function ($animate, $window, $timeout) {

        var fadeBg = angular.element('<div class="super-focus-bg"></div>');
        var body = angular.element('body');
        body.prepend(fadeBg);

        return {
            restrict: 'A',
            replace: true,
            scope: {
                focusOn: '=',
                dark: '='
            },
            link: function (scope, element) {

                var superData = {
                    showing: false
                };


                scope.$watch('focusOn', function(focused) {
                    if (focused) {
                        focus();
                    } else {
                        unfocus();
                    }
                });

                function focus() {
                    superData.showing = true;

                    if (scope.dark) {
                        fadeBg.addClass('dark');
                    }
                    element.addClass('super-focused');
                    element.find('*').addClass('super-focused-child');
                    body.addClass('super-focus-body');

                    $animate.addClass(fadeBg, 'show').then(function() {
                        superData.showing = false;

                    }).catch(function() {
                    });
                }
                function unfocus() {
                    $animate.removeClass(fadeBg, 'show').then(function() {
                        if (!superData.showing) {
                            //if focus is called before unfocus finishes, don't want to remove classes
                            body.removeClass('super-focus-body');
                            element.removeClass('super-focused');
                            element.find('*').removeClass('super-focused-child');
                            if (scope.dark) {
                                fadeBg.removeClass('dark');
                            }
                        }
                    }).catch(function(err) {
                    });
                }

                scope.$on('$destroy', function () {
                    unfocus();
                });

            }
        };
    }]);
})();
